import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.9,2.4H8.7c-0.3,0-0.6,0.3-0.6,0.8v1.6h2.8v2.3H8.1V14H5.5V7.1H3.1V4.8h2.4V3.5C5.4,1.7,6.8,0.1,8.6,0c0,0,0.1,0,0.1,0h2.2V2.4z"
	})
});
export { SvgIconFacebook as ReactComponent };
